import { Skeleton } from './ui/skeleton';

export default function HeroBillboardSkeleton() {
  return (
    <div className="relative h-[70vh] lg:h-[85vh] w-full overflow-hidden bg-[#141414]">
      {/* Background skeleton */}
      <div className="absolute inset-0">
        <Skeleton className="w-full h-full rounded-none" />
        
        {/* Gradients for better text readability */}
        <div className="absolute inset-0 hero-gradient" />
        <div className="absolute inset-0 hero-gradient-left" />
      </div>

      {/* Content skeleton */}
      <div className="relative h-full px-6 sm:px-8 lg:px-16 xl:px-20 flex items-end pb-20 lg:pb-28">
        <div className="max-w-2xl space-y-4 lg:space-y-5 w-full">
          {/* Title skeleton */}
          <Skeleton className="h-12 sm:h-16 lg:h-24 w-3/4 mb-4 bg-gray-700" />

          {/* Meta info skeleton */}
          <div className="flex items-center gap-4 mb-4">
            <Skeleton className="h-5 w-16 bg-gray-700" />
            <Skeleton className="h-5 w-20 bg-gray-700" />
            <Skeleton className="h-5 w-12 bg-gray-700" />
          </div>

          {/* Overview skeleton */}
          <div className="space-y-2 mb-6 max-w-xl">
            <Skeleton className="h-4 w-full bg-gray-700" />
            <Skeleton className="h-4 w-full bg-gray-700" />
            <Skeleton className="h-4 w-3/4 bg-gray-700" />
          </div>

          {/* Action buttons skeleton */}
          <div className="flex flex-wrap gap-3 mt-2">
            <Skeleton className="h-12 w-32 bg-gray-700" />
          </div>
        </div>
      </div>

      {/* Bottom fade to blend with content below */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#141414] to-transparent" />
    </div>
  );
}

